<div class="flex justify-center">
    <div class="rounded-3xl card w-4/5 md:max-lg:w-11/12 bg-base-100 shadow-xl -mt-24 lg:booking-form-mt">
        <div class="card-body">
            @if (showBookingText) {
            <div class="text-center">
                <ng-container *ngTemplateOutlet="bookingText" />
            </div>
            } @else {
            <form [formGroup]="bookingForm" class="grid gap-2 md:grid-cols-2 lg:grid-cols-7" (ngSubmit)="onSubmit()">
                <div class="lg:col-span-2">
                    <label class="text-base">Check-In Date</label>
                    <tui-input-date formControlName="checkinDate"  [max]="maxPossibleDate">
                        Choose a date
                        <input tuiTextfield />
                    </tui-input-date>
                </div>
                <div class="lg:col-span-2">
                    <label class="text-base">Check-Out Date</label>
                    <tui-input-date formControlName="checkoutDate" [min]="minPossibleCheckoutDate" [max]="maxPossibleDate">
                        Choose a date
                        <input tuiTextfield />
                    </tui-input-date>
                </div>
                <div class="md:col-span-2 lg:col-span-2">
                    <tui-hosted-dropdown [content]="dropdown" [(open)]="open" class="w-full" [tuiDropdownLimitWidth]="'fixed'">
                        <label class="text-base">Guests</label>
                        <tui-input [readOnly]="true" [pseudoFocus]="true">
                            {{ requirementText }}
                            <input tuiTextfield />
                        </tui-input>
                    </tui-hosted-dropdown>
                </div>
                <div class="place-self-center md:col-span-2 lg:col-span-1 lg:place-self-end">
                    <tui-loader class="loader" [inheritColor]="true" [overlay]="true" [showLoader]="loading">
                        <button size="l" tuiButton type="submit">Book Now</button>
                    </tui-loader>
                </div>
            </form>
            }
        </div>
    </div>
</div>

<ng-template #dropdown>
    <div class="card-body">
        <form [formGroup]="requirementsForm">
            <div class="">
                <!-- <label class="text-base">Rooms</label> -->
                <tui-input-number formControlName="rooms" [max]="6">
                    Rooms
                    <input tuiTextfield />
                </tui-input-number>
            </div>
            <div class="">
                <!-- <label class="text-base">Adults</label> -->
                <tui-input-number formControlName="adults" [max]="maxAdults" [min]="minAdults">
                    Adults
                    <input tuiTextfield />
                </tui-input-number>
            </div>
            <div class="">
                <!-- <label class="text-base">Child</label> -->
                <tui-input-number formControlName="child" [max]="maxChild" [min]="0">
                    Child
                    <input tuiTextfield />
                </tui-input-number>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #bookingText>
    <span class="text-base"
        >To book your stay please call <a class="btn book-now-btn" href="tel:+918972384814">+91 89723 84814</a> We're working on getting
        this feature ready.</span
    >
</ng-template>
